import React from 'react'
import { Document, Image, Page, Text, View } from '@react-pdf/renderer'

import lehrstellLogo from 'assets/images/logo-transparent.png'
import { getFormattedDiaryDate } from 'utils'
import { translation } from 'utils/germanTranslation'

const styles = {
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 20,
    borderBottom: '1px solid black',
    paddingBottom: 10,
    alignItems: 'center',
  },
  logo: {
    width: 50,
    height: 40,
  },
  title: {
    flex: 1,
  },
  userName: {
    flex: 1,
    textAlign: 'right',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#F0F2F9',
    borderBottomWidth: 1,
    borderBottomColor: '#bfbfbf',
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  headerCell: {
    padding: 5,
    fontSize: 11,
    fontWeight: 'bold',
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#bfbfbf',
  },
  tableCell: {
    padding: 5,
    fontSize: 10,
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#e0e0e0',
  },
  lastCell: {
    padding: 5,
    fontSize: 10,
    flex: 1,
  },
}

const EmailText = ({ email }) => {
  const atTheRate = email.indexOf('@')
  const emailStart = email.slice(0, atTheRate)
  const emailEnd = email.slice(atTheRate)
  return (
    <Text style={{ fontSize: 10 }}>
      {emailStart}
      {'\u00AD'}
      {emailEnd}
    </Text>
  )
}

const ExportDiary = ({ data, loggedInUser }) => {
  const columnWidths = [12, 14, 12, 15, 12, 12, 12]

  return (
    <Document title='Mein Lehrstell-Journal'>
      <Page wrap orientation='landscape' style={{ padding: 20 }}>
        <View style={styles.headerRow}>
          <Image src={lehrstellLogo} style={styles.logo} />
          <Text style={styles.title}>Mein Lehrstell-Journal</Text>
          <Text style={styles.userName}>
            {loggedInUser.firstName} {loggedInUser.lastName}
          </Text>
        </View>

        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableHeader}>
            <Text style={{ ...styles.headerCell, width: `${columnWidths[0]}%` }}>
              Beruf
            </Text>
            <Text style={{ ...styles.headerCell, width: `${columnWidths[1]}%` }}>
              Name der Firma
            </Text>
            <Text style={{ ...styles.headerCell, width: `${columnWidths[2]}%` }}>
              Kontaktperson
            </Text>
            <Text style={{ ...styles.headerCell, width: `${columnWidths[3]}%` }}>
              Kontakt E-Mail
            </Text>
            <Text style={{ ...styles.headerCell, width: `${columnWidths[4]}%` }}>
              Typ
            </Text>
            <Text style={{ ...styles.headerCell, width: `${columnWidths[5]}%` }}>
              Datum
            </Text>
            <Text style={{ ...styles.lastCell, width: `${columnWidths[6]}%` }}>
              {translation.notes}
            </Text>
          </View>

          {/* Table Rows */}
          {data.map((row, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={{ ...styles.tableCell, width: `${columnWidths[0]}%` }}>
                {row.job}
              </Text>
              <Text style={{ ...styles.tableCell, width: `${columnWidths[1]}%` }}>
                {row.companyName}
              </Text>
              <Text style={{ ...styles.tableCell, width: `${columnWidths[2]}%` }}>
                {row.contactPerson}
              </Text>
              <View style={{ ...styles.tableCell, width: `${columnWidths[3]}%` }}>
                <EmailText email={row.contactEmail} />
              </View>
              <Text style={{ ...styles.tableCell, width: `${columnWidths[4]}%` }}>
                {row.type}
              </Text>
              <Text style={{ ...styles.tableCell, width: `${columnWidths[5]}%` }}>
                {getFormattedDiaryDate(row)}
              </Text>
              <Text style={{ ...styles.lastCell, width: `${columnWidths[6]}%` }}>
                {row.notes}
              </Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default ExportDiary
